import GeneralUserProfileView from 'src/features/profile/views/profile-view'

const GeneralAppProfile = () => {
  return <GeneralUserProfileView />
}

export default GeneralAppProfile
